import React from 'react'
// components
import DataHubContainer from 'containers/DataHub'

const DataHubPage: React.FC = () => <DataHubContainer />

export default DataHubPage
